import { useMemo } from "react";
import { useParams } from "react-router-dom";

import ModuleChartSingleView from "../../components/chartSingleView";
import { formatOptions } from "../../service/common";
import { option_diagram } from "../../service/option/diagram";

export default function FrontIframeSingleChart() {
  const route_params = useParams();
  const iframeData = useMemo(() => {
    const optionData = formatOptions(
      {
        diagram: option_diagram,
      },
      {
        uniqueKey: "key",
        showLabel: "label",
        prefixKey: "key",
      }
    );
    const moduleData = optionData.diagram_obj[route_params.diagram];
    const groupData = option_diagram.find((group) =>
      (group.child || []).some(
        (item) => `${group.key}_${item.key}` === route_params.diagram
      )
    );
    const isValid =
      !!moduleData &&
      !!groupData &&
      (groupData.systemWeb || []).includes(route_params.systemWeb);

    return {
      isValid,
      moduleData: isValid ? moduleData : null,
    };
  }, [route_params]);

  return (
    <>
      <div className="w-full h-full">
        {iframeData.isValid ? (
          <ModuleChartSingleView
            systemWeb={route_params.systemWeb}
            moduleData={iframeData.moduleData}
          />
        ) : (
          <div className="text-center text-red-400 p-3">
            無效的 iframe 連結
          </div>
        )}
      </div>
    </>
  );
}
